const today = new Date();
const year = today.getFullYear();

module.exports = {
  apiUrl: `https://cyberistanbul.com:5017/`,
  footerText: `Copyright Cyber İstanbul © ${year}`,
};
